export interface VietnamAddress {
    address: string;
    province: string;
    isGiaLai: boolean;
  }
  
  export const VIETNAM_ADDRESSES: VietnamAddress[] = [
    { address: 'Phường Quy Nhơn Bắc', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Quy Nhơn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Quy Nhơn Tây', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Quy Nhơn Nam', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Quy Nhơn Đông', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Nhơn Châu', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã An Lão', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã An Vinh', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã An Toàn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã An Hòa', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Tam Quan', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Bồng Sơn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Hoài Nhơn Bắc', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Hoài Nhơn Tây', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Hoài Nhơn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Hoài Nhơn Đông', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Hoài Nhơn Nam', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Hoài Ân', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ân Hảo', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Vạn Đức', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ân Tường', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Kim Sơn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Phù Mỹ', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Bình Dương', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Phù Mỹ Bắc', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Phù Mỹ Đông', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Phù Mỹ Tây', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã An Lương', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Phù Mỹ Nam', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Vĩnh Thạnh', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Vĩnh Sơn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Vĩnh Thịnh', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Vĩnh Quang', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Tây Sơn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Bình Hiệp', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Bình Khê', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Bình An', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Bình Phú', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Phù Cát', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Đề Gi', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Hội Sơn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Hòa Hội', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Cát Tiến', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Xuân An', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ngô Mây', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Bình Định', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường An Nhơn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường An Nhơn Bắc', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường An Nhơn Đông', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã An Nhơn Tây', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường An Nhơn Nam', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Tuy Phước', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Tuy Phước Bắc', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Tuy Phước Đông', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Tuy Phước Tây', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Vân Canh', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Canh Liên', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Canh Vinh', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Diên Hồng', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Pleiku', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Thống Nhất', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Hội Phú', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Biển Hồ', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường An Phú', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Gào', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường An Bình', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường An Khê', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Cửu An', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Kbang', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Đak Rong', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Sơn Lang', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Krong', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Tơ Tung', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Kông Bơ La', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Đak Đoa', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Đak Sơmei', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Kon Gang', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Băng', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã KDang', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Chư Păh', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Khươl', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Ly', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Phí', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Grai', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Hrung', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Krái', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia O', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Chia', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Mang Yang', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ayun', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Hra', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Lơ Pang', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Kon Chiêng', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Kông Chro', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Chư Krey', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ya Ma', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã SRó', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Đăk Song', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Chơ Long', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Đức Cơ', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Krêl', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Dơk', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Dom', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Pnôn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Nan', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Chư Prông', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Bàu Cạn', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Tôr', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Boòng', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Púch', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Pia', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Lâu', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Mơ', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Chư Sê', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Chư Pưh', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Bờ Ngoong', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Al Bá', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Hrú', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Ko', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Le', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Đak Pơ', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ya Hội', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Pờ Tó', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Pa', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Tul', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Phú Thiện', province: 'Gia Lai', isGiaLai: true },
    { address: 'Phường Ayun Pa', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Chư A Thai', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Hiao', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Rbol', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Sao', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Phú Túc', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Dreh', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Uar', province: 'Gia Lai', isGiaLai: true },
    { address: 'Xã Ia Rsai', province: 'Gia Lai', isGiaLai: true },
  ];

export const BUDGET_OPTIONS = [
    'Dưới 1 Triệu',
    '1 Triệu-2 Triệu',
    '3 Triệu-5 Triệu',
    '5 Triệu-10 Triệu',
    '10 Triệu-20 Triệu',
    'Trên 20 Triệu',
    'Ngân sách khác'
];

export const SERVICE_TYPES = [
    'Xăm theo yêu cầu',
    'Xăm Blackwork',
    'Xăm Bán hiện thực',
    'Hình xăm lớn',
    'Xăm Tối giản',
    'Xăm Nhật cổ (Irezumi)'
];

export interface BookingFormData {
    fullName: string;
    email: string;
    phone: string;
    date: string;
    time: string;
    address: string;
    budget: string;
    serviceType: string;
    message: string;
    imageFile?: File;
}

export interface FormField {
    name: keyof BookingFormData;
    label: string;
    type: 'text' | 'email' | 'tel' | 'date' | 'textarea' | 'select' | 'radio';
    required: boolean;
    placeholder?: string;
    validation?: {
        pattern?: RegExp;
        message?: string;
    };
}

export interface DropdownOption {
    value: string;
    label: string;
}


